/* eslint-disable react-hooks/exhaustive-deps */
// import { Treemap } from '@ant-design/plots';
import { Gauge } from "@ant-design/plots";
import {
  Button,
  Collapse,
  Empty,
  Image,
  ImageViewer,
  Swiper,
} from "antd-mobile";
import Certificate from "components/alert/Certificate";
// import Share from "components/alert/Share";
import ProgressBarNew from "components/ProgressBarNew";
import transverterFn from "i18nData";
import { truncateString } from "modules/common";
import moment from "moment";
import About from "pages/commonBox/About";
import Header from "pages/commonBox/Header";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import r, { api } from "../../modules/Request";
import add_icon from "./../HomePage/images/add_icon.png";
import munus_icon from "./../HomePage/images/minus_icon.png";
import "./HomePage.scss";
import blockchainicon from "./images/blockchain.png";
import carbonjyicon from "./images/cabonjy.png";
import icon2 from "./images/icon_2.png";
import icon3 from "./images/icon_3.png";
import icon4 from "./images/icon_4.png";
import icon5 from "./images/icon_5.png";
import icon6 from "./images/icon_6.png";
import jd1icon from "./images/jd1.png";
import jd2icon from "./images/jd2.png";
import jd3icon from "./images/jd3.png";
import jd4icon from "./images/jd4.png";
import jd5icon from "./images/jd5.png";
import producttypeicon from "./images/producttype.png";
import productxhicon from "./images/productxh.png";
import productzlicon from "./images/productzl.png";
import productzqicon from "./images/productzq.png";
import rightarrrowicon from "./images/rightarrow.png";
const imgList = [icon2, icon3, icon4, icon5, icon6];
const jdimgLis = [jd1icon, jd2icon, jd3icon, jd4icon, jd5icon];
const zjcolors = ["#03BF8A", "#3192FF", "#FA9237", "#09B9B6", "#A185EB"];
const HomePage = () => {
  const history = useHistory();
  const { id, type } = r.getQueryString();
  const language = useSelector((state) => state.language);
  const dispatch = useDispatch();
  const imageViewerRef = useRef(0);
  const [visible, setVisible] = useState(false);
  const [technologyFlowImg, setTechnologyFlowImg] = useState(false);
  const [emissionimgList, setEmissionImgList] = useState([]);
  const [emissionimgListIdx, setEmissionImgListIdx] = useState(0);
  const [emissionimgListImg, setEmissionimgListImg] = useState(false);

  const [visibleImg, setVisibleImg] = useState(false);
  const [dataVal, setDataVal] = useState([]);
  const [txdataVal, settxdataVal] = useState();
  const [visitH5Data, setVisitH5Data] = useState(false); //控制中英文
  const [strAll, setStrAll] = useState({}); //写死的翻译数据
  const [resAll, setResAll] = useState([]); //接口返回的总数据
  const urlJoint = `id=${id?.slice(0, -1)}&type=${type}`;
  const config = {
    percent: parseFloat(resAll?.carbonReductionDetailVO?.ratio || 0) / 100,
    radius: 0.48,
    range: {
      color: ["#03BF8A", "#FFF"],
      width: 7,
    },
    startAngle: Math.PI - 0.5,
    endAngle: 2.14 * Math.PI,
    indicator: null,
    statistic: {
      title: {
        offsetY: -45,
        style: {
          fontSize: ".53rem",
          color: "#03BF8A",
          fontWeight: "600",
        },
        formatter: () => resAll?.carbonReductionDetailVO?.ratio || 0,
      },
      content: {
        style: {
          lineHeight: ".4rem",
          fontSize: ".27rem",
          color: "#333333",
          fontWeight: "400",
          marginTop: "-.4rem",
        },
        formatter: () => {
          return `<div>
            ${strAll?.ReductionRatio}
            <p>${visitH5Data ? "" : "(%)"}</p>
          </div>`;
        },
      },
    },
    gaugeStyle: {
      lineCap: "round",
    },
  };
  const getFillReviewFn = async () => {
    try {
      let res = await r.get(api.GET_FILLRE_VIEW + id);
      if (res.status.code === "00000") {
        let resData = res.data;
        setDataVal(resData);
      }
    } catch (e) {
      console.log(e);
    }
  };
  // 区块链弹窗
  const getDetails = async (id) => {
    const result = await r.get(`${api.CLOUDN_UPCHAIN_INFO}${id}`);
    if (result.status.code === "00000") {
      settxdataVal(result?.data);
      setVisible(true);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getFillReviewFn();
    // visitH5Fn();
  }, []);
  useEffect(() => {
    // filterLngFn();
  }, []);
  useEffect(() => {
    setEmissionImgList(resAll?.certificateImg);
  }, [resAll]);
  useEffect(() => {
    if (language) {
      setResAll(dataVal["zhProductDetail"]);
    } else {
      setResAll(dataVal["enProductDetail"]);
    }
    setStrAll(transverterFn(language));
  }, [language, dataVal]);
  useEffect(() => {
    document.title =
      resAll?.productName + (language ? "碳足迹" : " Carbon footprint");
  }, [resAll, language]);
  return (
    <div className="detail_box">
      <ImageViewer
        image={resAll?.carbonDistributtionImg}
        visible={visibleImg}
        getContainer={() => document.body}
        onClose={() => {
          setVisibleImg(false);
        }}
      />
      <ImageViewer
        image={resAll?.technologyFlowImg}
        visible={technologyFlowImg}
        getContainer={() => document.body}
        onClose={() => {
          setTechnologyFlowImg(false);
        }}
      />
      <ImageViewer.Multi
        ref={imageViewerRef}
        images={emissionimgList}
        visible={emissionimgListImg}
        defaultIndex={emissionimgListIdx}
        getContainer={() => document.body}
        onClose={() => {
          setEmissionimgListImg(false);
        }}
        onIndexChange={(i) => {
          console.log(emissionimgListIdx, i);
        }}
      />
      {/* <Share /> */}
      {/* <Certificate visible={visible} setVisible={setVisible} list={dataVal} /> */}
      <div className="app-content app-content-allbox">
        <div
          className="app-content-box white_box border_radius_hide"
          style={{ padding: ".1rem .32rem" }}
        >
          <Header
            resAll={resAll}
            visitH5Data={visitH5Data}
            setVisitH5Data={setVisitH5Data}
          />
          {resAll?.carbonLogo && (
            <Image
              className="carbonLogo"
              fit="contain"
              src={resAll?.carbonLogo}
            />
          )}
        </div>
        <div className="swiper_bor">
          <Swiper>
            {resAll?.boxPicList?.map((item, index) => {
              return (
                <Swiper.Item key={index}>
                  <div className="swiper_box">
                    <Image height="7.13rem" fit="contain" src={item} />
                  </div>
                </Swiper.Item>
              );
            })}
          </Swiper>
        </div>
        <div
          className="white_box border_radius_hide"
          style={{ padding: ".43rem" }}
        >
          <div className="detail_box_title" style={{ fontSize: ".64rem" }}>
            {resAll?.productName || "-"}
          </div>
          <div className="detail_box_tip">
            {/* 公司主体：浙江耀阳新材料科技有限公司 */}
            {strAll?.entName} {resAll?.entName || "-"}
          </div>
        </div>
        <div style={{ background: "#fff" }}>
          <div className="filleted_corner">
            <div className="content">
              <Collapse
                defaultActiveKey={["1", "2", "3", "4", "5", "6", "7"]}
                arrow={(active) =>
                  active ? (
                    <img className="icon_size" alt="" src={munus_icon} />
                  ) : (
                    <img className="icon_size" alt="" src={add_icon} />
                  )
                }
              >
                <Collapse.Panel
                  key="1"
                  title={strAll?.ProductInformation || "-"}
                >
                  <div className="white-item product-info-box">
                    <div className="product-info-box-item">
                      <img src={producttypeicon} alt="" />
                      <div className="item-right">
                        <p>{strAll?.productType || "-"}</p>
                        <p>{resAll?.productType || "-"}</p>
                      </div>
                    </div>
                    <div className="product-info-box-item">
                      <img src={productxhicon} alt="" />
                      <div className="item-right">
                        <p>{strAll?.productModel || "-"}</p>
                        <p>{resAll?.productModel || "-"}</p>
                      </div>
                    </div>
                    <div className="product-info-box-item">
                      <img src={productzqicon} alt="" />
                      <div className="item-right">
                        <p>{strAll?.productPeriod || "-"}</p>
                        <p>
                          {resAll?.fillTime?.[0] +
                            " - " +
                            resAll?.fillTime?.[1]}
                        </p>
                      </div>
                    </div>
                    <div className="product-info-box-tip">
                      <p>{strAll?.productionExplain}</p>
                      <p>{resAll?.productionExplain || ""}</p>
                    </div>
                  </div>
                </Collapse.Panel>
                <Collapse.Panel key="2" title={strAll?.ProcessProcess}>
                  {resAll?.technologyFlowImg && (
                    <div className="product-technology-box">
                      <img
                        onClick={() => {
                          setTechnologyFlowImg(true);
                        }}
                        src={resAll?.technologyFlowImg}
                        alt=""
                      />
                    </div>
                  )}
                  <div className="white-item product-Blockchain-box">
                    <p className="f48r bold">
                      <img src={blockchainicon} alt=""></img>
                      {strAll?.certificateAddress}

                      {/* <span className='detail_certificate_box' onClick={() => { setVisible(true) }}>查看证书 <RightOutlined style={{ fontWeight: 600 }} /></span> */}
                    </p>
                    <div className="hash-box">
                      <div className="detail_cz_box">
                        <p className="">Hash：</p>
                        <p className="detail_certificate_address">
                          {resAll?.certificateContent &&
                            truncateString(resAll?.certificateContent)}
                        </p>
                      </div>
                      <div
                        className={
                          resAll?.certificateAddress
                            ? "jump-box"
                            : "jump-box btn_disabled"
                        }
                        onClick={() => {
                          if (resAll?.certificateAddress) {
                            getDetails(
                              resAll?.certificateAddress.split("/")[6]
                            );
                          }
                        }}
                      >
                        <img src={rightarrrowicon} alt="" />
                      </div>
                    </div>
                  </div>
                </Collapse.Panel>
                <Collapse.Panel key="3" title={strAll?.ProductCarbonFootprint}>
                  <div className="white-item" style={{ padding: "0.11rem" }}>
                    <div className="card_gray_top">
                      <div className="product-carbon-box">
                        <div className="carbon-box-left">
                          <p>
                            {strAll?.LifeCycle}：{resAll?.bound}
                          </p>
                          <p>{resAll?.carbonReductionDetailVO?.featureUnit}</p>
                        </div>
                        <div>
                          <img src={carbonjyicon} alt="" />
                        </div>
                      </div>
                      <div className="product-carbonvalue-box">
                        <p className="value">{resAll?.carbon}</p>
                        <span>{resAll?.carbonUnit}</span>
                      </div>
                    </div>
                    <div className="product-carbonnumber-box">
                      <div className="box-content">
                        <p>{strAll?.ProductionQuantity}</p>
                        <p>
                          {resAll?.productionNum}
                          <span>{resAll?.productionUnit}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className="white-item product-bottom-box"
                    style={{ padding: ".13rem 0.45rem" }}
                  >
                    {resAll?.stepList?.map((item, idx) => {
                      return (
                        <div
                          key={item.stepKey}
                          className="product-bottom-box-item"
                        >
                          <div className="item-left">
                            <img src={jdimgLis?.[idx]} alt="" />
                            <p className="txt-ellipsis">{item?.name || "-"}</p>
                          </div>
                          <div className="item-right">
                            <p>
                              {item.emissionValueStr || "-"}{" "}
                              <span>{item.carbonUnit || "kg CO₂e"}</span>
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Collapse.Panel>
                {resAll?.carbonDistributtionImg && (
                  <Collapse.Panel key="4" title={strAll?.ProductOverview}>
                    <div className="white-item product-carbonoverview-box">
                      <img
                        onClick={() => {
                          setVisibleImg(true);
                        }}
                        src={resAll?.carbonDistributtionImg}
                        alt=""
                      />
                    </div>
                  </Collapse.Panel>
                )}
                <Collapse.Panel key="5" title={strAll?.ProductDistribution}>
                  <div className="center_box">
                    {resAll?.footDistributionList?.map((item, idx) => {
                      return (
                        <div
                          className="detail_distribution white_box"
                          key={idx}
                        >
                          <p
                            className="detail_distribution_title"
                            style={{ color: zjcolors[idx] }}
                          >
                            <img src={imgList[idx]} alt="" />
                            {item.stepKeyStr}
                          </p>
                          {item.rawList.length > 0 ? (
                            item.rawList.map((list, rawIdx) => {
                              return (
                                <ProgressBarNew
                                  key={rawIdx}
                                  emissionValue={list.emissionValue}
                                  unit={list.unit}
                                  title={list.rawName}
                                  color={zjcolors[idx]}
                                  percent={list.ratio}
                                  proportion={list.ratio}
                                />
                              );
                            })
                          ) : (
                            <Empty description="暂无数据" />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </Collapse.Panel>

                {resAll?.certificateImg?.length > 0 && (
                  <Collapse.Panel
                    key="6"
                    title={strAll?.CarbonReductionCertificationEvaluation}
                  >
                    <Swiper
                      onIndexChange={(i) => {
                        setEmissionImgListIdx(i);
                        imageViewerRef.current.swipeTo(i);
                        console.log(i, "onIndexChange1");
                      }}
                    >
                      {emissionimgList?.map((item, index) => {
                        return (
                          <Swiper.Item key={index}>
                            <div className="swiper_box">
                              <Image
                                onClick={() => {
                                  imageViewerRef.current.swipeTo(
                                    emissionimgListIdx
                                  );
                                  setEmissionimgListImg(true);
                                }}
                                height="7.13rem"
                                fit="contain"
                                src={item}
                              />
                            </div>
                          </Swiper.Item>
                        );
                      })}
                    </Swiper>
                  </Collapse.Panel>
                )}
                {resAll?.productTypeNew === "1" && (
                  <Collapse.Panel key="7" title={strAll?.OverviewProducts}>
                    <div
                      className="card_bor card_bor_green"
                      style={{ marginTop: 0 }}
                    >
                      <div className="card_green_top">
                        <div className="product-carbon-box">
                          <div className="carbon-box-left">
                            {/* <p>生命周期：{resAll?.bound}</p> */}
                            <p>
                              {/* {
                                resAll?.carbonReductionDetailVO
                                  ?.featureUnitImprove
                              } */}
                              {resAll?.carbonReductionDetailVO?.featureUnit}
                            </p>
                          </div>
                        </div>
                        <div className="product-carbonvalue-box block_max">
                          <p className="value">
                            {resAll?.carbonReductionDetailVO?.reductionCarbon}
                          </p>
                          <p className="unit">
                            {
                              resAll?.carbonReductionDetailVO
                                ?.carbonReductionUnit
                            }
                          </p>
                          <div
                            className="gauge_box"
                            style={{ right: "-.9rem" }}
                          >
                            <Gauge {...config} />
                          </div>
                        </div>
                      </div>
                      <div className="product-carbonnumber-box-green">
                        <div className="h32_box"></div>
                        <div className="box-content">
                          <p>
                            {strAll.BasicProduct}{" "}
                            {resAll?.carbonReductionDetailVO?.productNameBase}
                          </p>
                          <p>
                            {resAll?.carbonReductionDetailVO?.featureUnitBase}
                          </p>
                          <p>
                            {resAll?.carbonReductionDetailVO?.carbonBase}
                            <span>
                              {resAll?.carbonReductionDetailVO?.unitBase}
                            </span>
                          </p>
                        </div>
                        <div className="box-content box-content-green">
                          <p>
                            {strAll.ImprovedProduct}{" "}
                            {
                              resAll?.carbonReductionDetailVO
                                ?.productNameImprove
                            }
                          </p>
                          <p>
                            {
                              resAll?.carbonReductionDetailVO
                                ?.featureUnitImprove
                            }
                          </p>
                          <p>
                            {resAll?.carbonReductionDetailVO?.carbonImprove}
                            <span>
                              {resAll?.carbonReductionDetailVO?.unitImprove}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <Button
                      onClick={() => {
                        history.push("/emissionReduction?" + urlJoint);
                      }}
                      className="mt-18 detail_btnstyle"
                      block
                      color="success"
                    >
                      {strAll?.DetailsOfEmissionsReductions}
                    </Button>
                  </Collapse.Panel>
                )}
              </Collapse>
            </div>
          </div>
        </div>
        <About resAll={resAll} />
      </div>
      <Certificate
        visible={visible}
        setVisible={setVisible}
        list={{
          certificateContent: txdataVal?.hashCode,
          certificateAddress: txdataVal?.txid,
          blockHeight: txdataVal?.blockNumber,
          certificateTime: moment(txdataVal?.submitTime).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          certificateSubjects: txdataVal?.entName,
          geoLocation: txdataVal?.businessAddress,
          hashname: "存证哈希",
          addressname: "链上交易ID",
        }}
      />
    </div>
  );
};

export default HomePage;
